import { stringifyQs } from "@dashboard/utils/urls";
import urlJoin from "url-join";

export const htmlManagerSection = "/html-manager/";

export enum HtmlManagerUrlDialog {
  DELETE = "delete",
}

export enum HtmlManagerUrlQueryParams {
  DIALOG = "dialog",
}

export const htmlManagerListPath = "/html-manager/";

export const htmlManagerPath = (id: string) => urlJoin(htmlManagerSection, id);

export const htmlManagerAddPath = urlJoin(htmlManagerSection, "add");

export const htmlManagerUrl = (id: string, params?: any) =>
  htmlManagerPath(encodeURIComponent(id)) + "?" + stringifyQs(params);

export const htmlManagerListUrl = (params?: any): string =>
  htmlManagerListPath + "?" + stringifyQs(params);

export const htmlManagerAddUrl = (params?: any) =>
  htmlManagerAddPath + "?" + stringifyQs(params);